// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__plpnV","button":"Button_button__1V2jy","Link":"Button_Link__2E8Ic"};